import { css } from 'styled-components';

export default css`
  .fal {
    margin-left: 7px;
    font-size: 0.9em;
  }
`;
